import { Type_Map_Formatted } from "src/types/map";

import { Type_Map, Type_Position } from "./types";

export const formatterGetMap = (map: Type_Map): Type_Map_Formatted => {
    return {
        id: map.id,
        label: map.label,
        url: map.url,
        bound: map.bound.coordinates,
        minZoom: map.min_zoom,
        maxZoom: map.max_zoom,
        type: map.type,
        startDate: map.start_date,
        endDate: map.end_date,
        user_id: map.user_id,
    };
};

export const formatterImageCoordsToExtent = (coordinates: Type_Position[]) => {
    const [bottomLeft, topRight] = [coordinates[0], coordinates[1]];

    return [...bottomLeft, ...topRight];
};
